import { useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { useMyBetsQuery } from "../../../store/service/clientBetService";
import "./Client.scss";

const FILTERS = [
  { id: "all", label: "All" },
  { id: "open", label: "Open" },
  { id: "won", label: "Won" },
  { id: "lost", label: "Lost" },
];

const statusClass = (status) => {
  if (status === "won") return "bet-status-won";
  if (status === "lost") return "bet-status-lost";
  return "bet-status-open";
};

const betTypeLabel = (type, market) => {
  if (market === "fancy" || String(market).includes("fancy")) {
    return type === "back" ? "YES" : "NO";
  }
  return type === "back" ? "LAGAI" : "KHAI";
};

const ClientMyBets = () => {
  const nav = useNavigate();
  const [filter, setFilter] = useState("all");
  const { data, isLoading, isFetching } = useMyBetsQuery(undefined, {
    pollingInterval: 5000,
  });

  const allBets = data?.data?.betList || [];

  const bets = useMemo(() => {
    if (filter === "all") return allBets;
    return allBets.filter((b) => b.status === filter);
  }, [allBets, filter]);

  const counts = useMemo(
    () => ({
      all: allBets.length,
      open: allBets.filter((b) => b.status === "open").length,
      won: allBets.filter((b) => b.status === "won").length,
      lost: allBets.filter((b) => b.status === "lost").length,
    }),
    [allBets]
  );

  const openMatch = (matchId) => {
    if (!matchId) return;
    nav(`/play/match/${matchId}`);
  };

  return (
    <div className="lotus-home">
      <div className="lotus-section-title">Bet history</div>

      <div className="bet-history-filters">
        {FILTERS.map((f) => (
          <button
            key={f.id}
            type="button"
            className={filter === f.id ? "active" : ""}
            onClick={() => setFilter(f.id)}>
            {f.label}
            <br />
            <span style={{ fontWeight: 600, opacity: 0.7 }}>{counts[f.id]}</span>
          </button>
        ))}
      </div>

      {isLoading && bets.length === 0 ? (
        <div className="lotus-loading">
          <Spin />
        </div>
      ) : bets.length === 0 ? (
        <div className="lotus-empty">
          {filter === "all" ? "No bets yet" : `No ${filter} bets`}
        </div>
      ) : (
        <div className="bet-history-list">
          {bets.map((bet) => (
            <div key={bet.betId} className={`bet-list-item ${statusClass(bet.status)}`}>
              <div className="bet-item-top">
                <span className={`bet-status-pill ${statusClass(bet.status)}`}>
                  {bet.status?.toUpperCase()}
                </span>
                <span className="bet-item-date">{bet.settledOn || bet.placedOn}</span>
              </div>
              {bet.matchId ? (
                <button
                  type="button"
                  className="title bet-match-link"
                  onClick={() => openMatch(bet.matchId)}>
                  {bet.matchName}
                </button>
              ) : (
                <div className="title">{bet.matchName}</div>
              )}
              <div className="bet-item-body">
                <div>
                  {bet.selection}
                  <br />
                  <span className="bet-type-tag">
                    {betTypeLabel(bet.betType, bet.marketType)} @ {bet.odds}
                  </span>
                </div>
                <div className="bet-item-nums">
                  <div>
                    Stake <strong>{bet.stake}</strong>
                  </div>
                  <div>
                    Profit <strong>{bet.potentialWin ?? "—"}</strong>
                  </div>
                  {bet.payout > 0 ? (
                    <div className="bet-credited">+{bet.payout} credited</div>
                  ) : null}
                </div>
              </div>
              {bet.resultValue != null ? (
                <div className="bet-result-line">Result: {bet.resultValue} runs</div>
              ) : null}
              {bet.resultWinner ? (
                <div className="bet-result-line">Winner: {bet.resultWinner}</div>
              ) : null}
              {bet.matchId ? (
                <Link to={`/play/match/${bet.matchId}`} className="bet-open-match">
                  Open match →
                </Link>
              ) : null}
            </div>
          ))}
        </div>
      )}

      {isFetching && bets.length > 0 ? (
        <div className="profile-refresh">Refreshing…</div>
      ) : null}
    </div>
  );
};

export default ClientMyBets;
